import React, { useContext } from 'react';
import modalContext from '../../context/modal/modalContext';
import CustomModal from '../../components/CustomModal';
import ExternalLink from '../../components/ExternalLink';
import { config } from '../../config/config';
import { CrossIcon, SuccessIcon } from '../../assets/icons';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../config/constants';

const SuccessModal: React.FC = () => {
    const { modalData, closeModal } = useContext(modalContext);
    const { chainId } = useWeb3React();
    const onClose = () => closeModal('successModal');

    return (
        <CustomModal modalName='successModal' className='success-modal'>
            <button type='button' onClick={onClose}>
                <CrossIcon />
            </button>
            <SuccessIcon />
            <div
                className='status'
                dangerouslySetInnerHTML={{ __html: modalData?.status }}
            />
            {modalData?.message ? (
                <div className='message'>{modalData?.message}</div>
            ) : null}
            {modalData?.txHash ? (
                <div className='link'>
                    <ExternalLink
                        to={`${
                            chainId !== SupportedChains.ARBITRUM_ONE
                                ? config.urls.etherscan
                                : config.urls.arbiscan
                        }/tx/${modalData.txHash}`}
                    >
                        View on{' '}
                        {chainId !== SupportedChains.ARBITRUM_ONE
                            ? 'Etherscan'
                            : 'Arbiscan'}
                    </ExternalLink>
                </div>
            ) : null}
        </CustomModal>
    );
};

export default SuccessModal;
